export const sendWhatsApp = (phoneNumber: string, text?: string): void => {
  let cleanPhone = phoneNumber?.replace('+', '');
  cleanPhone = cleanPhone.startsWith('0') ? cleanPhone.substring(1) : cleanPhone;
  cleanPhone = cleanPhone.startsWith('972') ? cleanPhone : `972${cleanPhone}`
  let url = `https://wa.me/${cleanPhone}`;
  if (text)
    url += `?text=${text}`;
  window.open(url, '_blank')?.focus();
}
